import { Box, Typography, IconButton } from "@mui/material";
import { ReactNode } from "react";
import CloseIcon from "@mui/icons-material/Close";

export interface ModalTopBarProps {
  handleClose: () => void;
  title: ReactNode | string;
  headerChildren?: ReactNode;
  customCloseButton?: ReactNode;
}

const ModalTopBar = ({ handleClose, title, headerChildren, customCloseButton }: ModalTopBarProps) => {
  return (
    <Box
      sx={(theme) => ({
        display: "block",
        height: "67px",
        minHeight: "67px",
        maxHeight: "67px",
        flexShrink: 0,
      })}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: `${theme.spacing(3)} ${theme.spacing(6)}`,
          top: 0,
          zIndex: 2,
          borderBottom: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.default,
          flexWrap: "wrap",
        })}
      >
        <Box
          sx={(theme) => ({
            display: "flex",
            gap: theme.spacing(3),
            maxWidth: "calc(100% - 50px)",
          })}
        >
          <Typography
            variant="h4"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            {title}
          </Typography>
          {headerChildren}
        </Box>
        {customCloseButton ? (
          customCloseButton
        ) : (
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default ModalTopBar;
